module.exports = __webpack_public_path__ + "img/327.6b184c8c.png";